<template>
    <div>
        <v-hover v-slot="{ isHovering, props }">
            <v-card
                v-bind="props"
                :elevation="isHovering ? 4 : 0"
                :class="
                    $vuetify.display.mobile
                        ? 'default_card_mobile dashboard_card d-flex flex-column ma-0'
                        : 'default_card dashboard_card d-flex flex-column ma-0'
                "
                :style="$vuetify.display.mobile ? 'height: 100%' : 'height: 250px'"
            >
                <v-row no-gutters v-if="!vueGraph">
                    <v-col cols="12" class="title ma-0 pa-2 pb-0">
                        {{ Title }}
                    </v-col>
                    <v-col cols="12" class="title ma-0 pb-0 d-flex justify-center">
                        {{ subtitle }}
                    </v-col>
                    <v-col cols="12" class="px-4">
                        <v-row no-gutters v-if="!vueGraph && !vueDetailed">
                            <v-col
                                :cols="$vuetify.display.mdAndDown ? '12' : '7'"
                                class="d-flex flex-column justify-center align-center"
                            >
                                <h1 v-if="!$vuetify.display.mobile">
                                    {{ newCommonFormatCurrency(solde, undefined) }}
                                </h1>
                                <h2 v-else>{{ newCommonFormatCurrency(solde, undefined) }}</h2>
                                <h3 class="d-flex justify-center" style="font-size: x-small">
                                    {{ diagnostic }}
                                </h3>
                                <!-- explication -->
                            </v-col>
                            <v-col
                                class="d-flex flex-column justify-end align-center"
                                :cols="$vuetify.display.mdAndDown ? '12' : '5'"
                            >
                                <v-row no-gutters>
                                    <v-col cols="4" class="d-flex">
                                        Banque
                                        <!-- Débit -->
                                    </v-col>
                                    <v-col cols="8" class="d-flex font-weight-bold justify-end">
                                        <span>
                                            {{
                                                newCommonFormatCurrency(bankAmount, undefined)
                                            }}</span
                                        >
                                    </v-col>
                                    <v-col cols="4" class="d-flex">
                                        Factures
                                        <!-- Crédit -->
                                    </v-col>
                                    <v-col cols="8" class="d-flex font-weight-bold justify-end">
                                        <span>{{
                                            newCommonFormatCurrency(documentAmount, undefined)
                                        }}</span>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" class="mt-auto">
                        <v-row no-gutters class="pa-2">
                            <v-col cols="1" class="d-flex justify-center">
                                <v-btn-prev class="mx-1" @click="previous"> </v-btn-prev>
                            </v-col>
                            <v-col class="d-flex justify-center">
                                <v-btn-icon
                                    icon="$home"
                                    v-if="isHovering && indexlistOpenPoints != 0"
                                    @click="indexlistOpenPoints = 0"
                                >
                                </v-btn-icon>
                                <v-btn-icon
                                    icon="$fa-chart-bar"
                                    v-if="isHovering && indexlistOpenPoints != 0"
                                    @click="vueGraph = true"
                                >
                                </v-btn-icon>
                                <v-btn-icon
                                    icon="$fa-search-plus"
                                    v-if="
                                        !$vuetify.display.mobile &&
                                        isHovering &&
                                        indexlistOpenPoints != 0
                                    "
                                    @click="vueDetailed = true"
                                >
                                </v-btn-icon>
                            </v-col>
                            <v-col cols="1" class="d-flex justify-center">
                                <v-btn-next class="mx-1" @click="next"> </v-btn-next>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row no-gutters v-else>
                    <v-col cols="12" class="ma-2 mb-0 py-0"> Statut des factures en cours </v-col>
                    <v-col cols="12" class="ma-2 mb-0 py-0 d-flex justify-center">
                        {{ subtitle }}
                    </v-col>
                    <v-col cols="12" class="py-0">
                        <template v-if="generalLedgerDetailsLoading">
                            <v-progress-circular
                                :size="70"
                                :width="7"
                                color="primary"
                                indeterminate
                                style="margin: 24px"
                            />
                        </template>
                        <bar-chart
                            v-else-if="chartData"
                            :data="chartData"
                            :options="options"
                            :height="$vuetify.display.mobile ? 75 : 90"
                        />
                    </v-col>
                </v-row>
                <v-row
                    no-gutters
                    class="mt_auto d-flex align-end"
                    style="min-height: 3rem"
                    v-if="vueGraph"
                >
                    <v-col cols="12" class="d-flex justify-center">
                        <v-btn-icon icon="$fa-search-minus" @click="vueGraph = false"> </v-btn-icon>
                    </v-col>
                </v-row>
            </v-card>
        </v-hover>
        <oss-dialog minWidth="1200px" v-model="vueDetailed" :title="detailedDialogTitle">
            <AccountableAccountBalanceDetailOpenPoints
                :companyId="companyId"
                :accountingPeriodId="accountingPeriodId"
                mode="openPoints"
                :notReconciliated="true"
                :accountableAccountInfo="accountableAccountInfo"
                :inAccountingTransactions="accountableAccountInfo.accountingTransactions"
                @bankTransactionSelected="onBankTransactionSelected($event)"
            >
            </AccountableAccountBalanceDetailOpenPoints>
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import gql from "graphql-tag";
import moment from "moment-timezone";

import { Bar as BarChart } from "vue-chartjs";

import { chartColors } from "../../../backend/src/common/chart/graphServices";
import { newCommonFormatCurrency } from "../../../backend/src/common/services/mathServices";

import { AccountingPeriod } from "../../../types";

import GENERAL_LEDGER from "../graphql/GeneralLedger.gql";
import GENERAL_LEDGER_DETAILS from "../graphql/GeneralLedgerDetail.gql";

import { Apollo } from "@/decorators";

import AccountableAccountBalanceDetailOpenPoints from "./AccountableAccountBalanceDetailOpenPoints.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        BarChart,
        AccountableAccountBalanceDetailOpenPoints,
    },
    emits: ["display"],
})
export class CardBalance extends Vue {
    @Prop({ default: "" }) companyId: string;
    // @Prop({ default: "411" }) thirdPartyType: string; //used when only one accountable account is needed
    // @Prop({ default: "411" }) thirdParty: string;
    @Prop({ default: [] }) accountableAccounts: Array<string>; //replace thirdPartyType when multiple accountableAccounts are needed => this logic is based on generalLedger

    thirdParty = true;

    vueDetailed = false; // show vue detailed if true
    vueGraph = false;
    indexlistOpenPoints = 0;

    get typeName() {
        return this.accountableAccounts.join("-");
    }

    get accountingPeriodId() {
        if (this.accountingPeriods && this.accountingPeriods.length) {
            return this.accountingPeriods[0].id;
        }
        return "";
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    // get listGeneralLedger() {   // Pour qu'elle fonctionne remplacer tous les listOpenPoints par listGeneralLedger  => même card mais avec la query GeneralLedger plutôt que GetAuxiliaryOpenPoints
    //     const result = []
    //     if (this.generalLedger.length > 0) {
    //         let totalCredit = 0
    //         let totalDebit = 0
    //         for (const gl of this.generalLedger) {
    //             if (gl.thirdPartyCompanyName) {
    //                 result.push({title: gl.thirdPartyCompanyName, debit: gl.totalDebit, credit: gl.totalCredit, solde: gl.totalDebit - gl.totalCredit})
    //             } else {
    //                 result.push({title: gl.description + " non précisés", debit: gl.totalDebit, credit: gl.totalCredit, solde: gl.totalDebit - gl.totalCredit})
    //             }
    //             totalCredit += gl.totalCredit
    //             totalDebit += gl.totalDebit
    //         }
    //         result.sort((a, b) => (Math.abs(a.solde) < Math.abs(b.solde) ? 1 : -1))
    //         result.unshift({title: "Total", debit: totalDebit, credit: totalCredit, solde: totalDebit - totalCredit})
    //     }
    //     return result
    // }

    get listOpenPoints() {
        const result = [];
        if (this.openPoints.length > 0) {
            let totalBankAmount = 0;
            let totalDocumentAmount = 0;
            const aaNames = [];
            // console.log(this.typeName);
            if (this.isSortedByUser) {
                for (const op of this.openPoints) {
                    if (aaNames.indexOf(op.name) === -1) {
                        aaNames.push(op.name);
                    }
                    if (this.accountableAccounts.indexOf(op.name.substring(0, 3)) !== -1) {
                        if (op.userId) {
                            result.push({
                                aaName: op.name,
                                title: op.firstname + " " + op.lastname,
                                userId: op.userId,
                                diagnostic: op.diagnostic,
                                bankAmount: this.checkBankAmount(op),
                                documentAmount: this.checkDocAmount(op),
                                solde: op.amountSigned,
                            });
                        } else {
                            result.push({
                                aaName: op.name,
                                title: op.description + " non précisés",
                                userId: null,
                                diagnostic: op.diagnostic,
                                bankAmount: this.checkBankAmount(op),
                                documentAmount: this.checkDocAmount(op),
                                solde: op.amountSigned,
                            });
                        }
                        totalBankAmount += this.checkBankAmount(op);
                        totalDocumentAmount += this.checkDocAmount(op);
                    }
                }
            } else if (this.isSortedByCompany) {
                for (const op of this.openPoints) {
                    if (this.accountableAccounts.indexOf(op.name.substring(0, 3)) !== -1) {
                        if (op.thirdPartyCompanyName) {
                            result.push({
                                aaName: op.name,
                                title: op.thirdPartyCompanyName,
                                diagnostic: op.diagnostic,
                                bankAmount: this.checkBankAmount(op),
                                documentAmount: this.checkDocAmount(op),
                                solde: op.amountSigned,
                            });
                        } else {
                            result.push({
                                aaName: op.name,
                                title: op.description + " non précisés",
                                diagnostic: op.diagnostic,
                                bankAmount: this.checkBankAmount(op),
                                documentAmount: this.checkDocAmount(op),
                                solde: op.amountSigned,
                            });
                        }
                        totalBankAmount += this.checkBankAmount(op);
                        totalDocumentAmount += this.checkDocAmount(op);
                    }
                }
            } else {
                for (const op of this.openPoints) {
                    if (op.name && (op.bankTransaction || op.document)) {
                        // condition pour exclure les carryForward
                        result.push({
                            title: op.description,
                            aaName: op.name,
                            diagnostic: "",
                            bankAmount: this.checkBankAmount(op),
                            documentAmount: this.checkDocAmount(op),
                            solde: op.amountSigned,
                        });
                        //result.push({title: op.description, diagnostic: "", bankAmount: 0, documentAmount: this.checkDocAmount(op), solde: op.amountSigned})
                        totalBankAmount += this.checkBankAmount(op);
                        totalDocumentAmount += this.checkDocAmount(op);
                    } else if (!op.name) {
                        debugger; // git-ignore
                    }
                }
            }
            result.sort((a, b) => (Math.abs(a.solde) < Math.abs(b.solde) ? 1 : -1));
            const solde = totalBankAmount + totalDocumentAmount;
            result.unshift({
                aaName: aaNames.length === 1 || aaNames[0],
                title: "Total",
                diagnostic: "",
                bankAmount: totalBankAmount,
                documentAmount: totalDocumentAmount,
                solde: solde,
            });
        }
        // console.log(this.typeName, " result.length= ", result.length);
        if (result.length) {
            this.$emit("display", true);
        } else {
            this.$emit("display", false);
        }
        return result;
    }

    get isSortedByUser() {
        if (
            this.typeName === "421" ||
            this.typeName === "455" ||
            this.typeName === "467" ||
            this.typeName === "425"
        ) {
            return true;
        }
        return false;
    }

    get isSortedByCompany() {
        if (this.typeName === "401" || this.typeName === "411") {
            return true;
        }
        return false;
    }

    get Title() {
        if (this.typeName === "401") {
            if (this.indexlistOpenPoints === 0) {
                return "Total solde fournisseurs";
            }
            return "Solde fournisseur";
        }
        if (this.typeName === "411") {
            if (this.indexlistOpenPoints === 0) {
                return "Total solde clients";
            }
            return "Solde client";
        }
        if (this.typeName === "421") {
            if (this.indexlistOpenPoints === 0) {
                return "Total solde salaires";
            }
            return "Solde Employé";
        }
        if (this.typeName === "455") {
            if (this.indexlistOpenPoints === 0) {
                return "Total solde associés";
            }
            return "Solde Associé";
        }
        if (this.typeName === "467") {
            if (this.indexlistOpenPoints === 0) {
                return "Total solde notes de frais";
            }
            return "Solde note de frais";
        }
        if (this.typeName === "425") {
            if (this.indexlistOpenPoints === 0) {
                return "Total solde personnel";
            }
            return "Solde personnel";
        }
        if (this.typeName === "511-531" || this.typeName === "531-511") {
            if (this.indexlistOpenPoints === 0) {
                return "Total solde Z de caisses";
            }
            return "Solde Z de caisses";
        }
        if (this.indexlistOpenPoints === 0) {
            return "Total solde";
        }
        return "Solde";
    }

    get subtitle() {
        if (this.indexlistOpenPoints != 0) {
            return this.listOpenPoints[this.indexlistOpenPoints].title;
        }
        return "";
    }

    get solde() {
        if (
            this.indexlistOpenPoints < this.listOpenPoints.length &&
            this.listOpenPoints[this.indexlistOpenPoints].solde != undefined
        ) {
            return this.listOpenPoints[this.indexlistOpenPoints].solde;
        }
        return null;
    }

    get bankAmount() {
        if (
            this.indexlistOpenPoints < this.listOpenPoints.length &&
            this.listOpenPoints[this.indexlistOpenPoints].bankAmount != undefined
        ) {
            return this.listOpenPoints[this.indexlistOpenPoints].bankAmount;
        }
        return null;
    }

    get documentAmount() {
        if (
            this.indexlistOpenPoints < this.listOpenPoints.length &&
            this.listOpenPoints[this.indexlistOpenPoints].documentAmount != undefined
        ) {
            return this.listOpenPoints[this.indexlistOpenPoints].documentAmount;
        }
        return null;
    }

    get detailedDialogTitle() {
        return "Détails du " + this.Title.replace("S", "s");
    }

    checkBankAmount(op: any) {
        if (op.bankTransaction && op.bankTransaction.amountSigned) {
            return op.bankTransaction.amountSigned;
        }
        return 0;
    }

    checkDocAmount(op: any) {
        if (op.document && op.document.amountSigned) {
            return op.document.amountSigned;
        }
        return 0;
    }

    get credit() {
        if (
            this.listOpenPoints.length >= this.indexlistOpenPoints &&
            this.listOpenPoints[this.indexlistOpenPoints].credit != undefined
        ) {
            return this.listOpenPoints[this.indexlistOpenPoints].credit;
        }
        return null;
    }

    get debit() {
        if (
            this.listOpenPoints.length >= this.indexlistOpenPoints &&
            this.listOpenPoints[this.indexlistOpenPoints].debit != undefined
        ) {
            return this.listOpenPoints[this.indexlistOpenPoints].debit;
        }
        return null;
    }

    get thirdPartyCompanyName() {
        if (this.accountableAccounts.length > 1) {
            return undefined;
        }
        if (this.isSortedByUser) {
            return undefined;
        }
        if (this.indexlistOpenPoints != 0) {
            if (this.listOpenPoints[this.indexlistOpenPoints].title.includes(" non précisés")) {
                return null;
            }
            return this.listOpenPoints[this.indexlistOpenPoints].title;
        }
        return null;
    }

    get userId() {
        if (this.isSortedByUser) {
            if (this.indexlistOpenPoints != 0) {
                if (this.listOpenPoints[this.indexlistOpenPoints].title.includes(" non précisés")) {
                    return null;
                }
                return this.listOpenPoints[this.indexlistOpenPoints].userId;
            }
            return null;
        } else {
            return undefined;
        }
    }

    get accountableAccountInfoName() {
        // if(this.accountableAccounts.length < 2) {
        //     return ""
        // }
        if (
            this.indexlistOpenPoints >= 0 &&
            this.indexlistOpenPoints < this.listOpenPoints.length
        ) {
            return this.listOpenPoints[this.indexlistOpenPoints].aaName || "";
        }
        return "";
    }

    get diagnostic() {
        if (this.indexlistOpenPoints != 0) {
            if (this.listOpenPoints[this.indexlistOpenPoints].diagnostic) {
                return this.listOpenPoints[this.indexlistOpenPoints].diagnostic;
            }
        }
        return "";
    }

    next() {
        if (this.indexlistOpenPoints >= this.listOpenPoints.length - 1) {
            this.indexlistOpenPoints = 0;
        } else {
            this.indexlistOpenPoints++;
        }
    }

    previous() {
        if (this.indexlistOpenPoints <= 0) {
            this.indexlistOpenPoints = this.listOpenPoints.length - 1;
        } else {
            this.indexlistOpenPoints--;
        }
    }

    @Apollo({
        query: gql`
            query ($companyId: ID!) {
                accountingPeriods(
                    where: { company: { id: $companyId } }
                    orderBy: start_DESC
                    first: 1
                ) {
                    id
                    start
                    end
                    company {
                        id
                    }
                }
            }
        `,
        skip() {
            return !this.companyId;
        },
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data && data.accountingPeriods) {
                if (data.accountingPeriods.length) {
                    this.accountingPeriods = data.accountingPeriods;

                    // if (this.accountingPeriod) {
                    //     const accountingPeriod = this.accountingPeriods.find(ap => ap.id === this.accountingPeriod.id);
                    //     if (accountingPeriod) {
                    //         this.accountingPeriod = accountingPeriod
                    //     } else {
                    //         this.accountingPeriod = null
                    //     }
                    // }

                    // if (this.accountingPeriods && this.accountingPeriods.length && !this.accountingPeriod) {
                    //     this.accountingPeriod = this.accountingPeriods[this.accountingPeriods.length - 1];
                    // }
                } else {
                    // this.accountingPeriod = null;
                    this.accountingPeriods = [];
                }
            } else {
                // this.accountingPeriod = null;
                this.accountingPeriods = [];
            }
        },
        debounce: 500,
    })
    accountingPeriods: AccountingPeriod[] = [];

    @Apollo({
        query: GENERAL_LEDGER,
        variables() {
            return {
                companyId: this.companyId,
                accountingPeriodId: this.accountingPeriodId,
                thirdPartyType: this.accountableAccounts.length === 1 ? this.typeName : "",
                accountableAccountFilter:
                    this.accountableAccounts.length > 1 ? this.accountableAccounts : undefined,
                notReconciliated: true,
                splitedByDocumentsAndBT: true,
            };
        },
        skip() {
            return !this.companyId || !this.accountingPeriodId || !this.accountableAccounts?.length;
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.indexlistOpenPoints = 0;
            if (data) {
                if (data.generalLedger && data.generalLedger.generalLedger) {
                    this.openPoints = data.generalLedger.generalLedger;
                } else {
                    this.openPoints = [];
                }
            } else {
                this.openPoints = [];
            }
        },
    })
    openPoints: any[] = [];

    @Apollo({
        query: GENERAL_LEDGER_DETAILS,
        variables() {
            return {
                companyId: this.companyId,
                accountingPeriodId: this.accountingPeriodId,
                notReconciliated: true,
                accountableAccountName: this.accountableAccountInfoName,
                thirdPartyCompanyId: this.thirdPartyCompanyId,
                userId: this.userId,
                mode: "MANAGEMENT",
            };
        },
        skip() {
            return (
                !this.vueGraph ||
                !this.companyId ||
                !this.accountingPeriodId ||
                !this.accountableAccountInfoName
            );
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (data) {
                if (data.generalLedgerDetail && data.generalLedgerDetail.detail) {
                    this.generalLedgerDetails = data.generalLedgerDetail.detail;
                } else {
                    this.generalLedgerDetails = [];
                }
            } else {
                this.generalLedgerDetails = [];
            }
        },
    })
    generalLedgerDetails: any = [];

    get generalLedgerDetailsLoading() {
        if (this.$apollo.queries.generalLedgerDetails) {
            return this.$apollo.queries.generalLedgerDetails.loading;
        }
        return false;
    }

    get chartData() {
        //this.$apollo.queries.generalLedgerDetails.refetch()
        const now = moment();
        let bankAmount = 0;
        let waitAmount = 0;
        let lateAmount = 0;
        let veryLateAmount = 0;
        for (const al of this.generalLedgerDetails) {
            if (al.object.type === "bankTransaction") {
                bankAmount += al.debit - al.credit;
            } else {
                const date = moment(al.date);
                const dueDate = al.dueDate ? moment(al.dueDate) : date;
                const diff = dueDate.diff(now, "days");
                if (diff >= 0) {
                    waitAmount += al.debit - al.credit;
                } else if (diff <= -30) {
                    veryLateAmount += al.debit - al.credit;
                } else {
                    lateAmount += al.debit - al.credit;
                }
            }
        }
        const datasets = [
            //{ data: [-veryLateAmount, -lateAmount, -waitAmount, bankAmount] }
            //{ data: [waitAmount]}, {data: [veryLateAmount]}
            {
                label: "En attente",
                data: [waitAmount],
                backgroundColor: "red",
                stack: "Stack 0",
            },
            {
                label: "En retard",
                data: [lateAmount],
                backgroundColor: "blue",
                stack: "Stack 0",
            },
            {
                label: "Très en retard",
                data: [veryLateAmount],
                backgroundColor: "green",
                stack: "Stack 0",
            },
            {
                label: "Règlements",
                data: [-bankAmount],
                stack: "Stack 1",
            },
        ];
        chartColors("bar", datasets, "cool");
        const result = {
            axis: "y",
            labels: [""],
            datasets: datasets,
        };
        return result;
    }

    get accountableAccountInfo() {
        return {
            name: this.accountableAccountInfoName,
            thirdPartyCompanyName: this.thirdPartyCompanyName,
            userId: this.userId,
            diagnostic: this.diagnostic,
            accountingTransactions: [],
        };
    }

    // get completeAccountableAccountName(){
    //     if(this.completeAccountableAccountRootName) {
    //         return this.completeAccountableAccountRootName.padEnd(6, '0')
    //     }
    //     return ""
    // }

    get completeAccountableAccountRootName() {
        if (this.accountableAccounts.length > 1) {
            return "";
        } else {
            return this.accountableAccounts[0];
        }
    }

    get options() {
        return {
            responsive: true,
            plugins: {
                legend: { display: false },
                tooltip: {
                    mode: "index",
                    position: "average",
                    callbacks: {
                        title: () => {
                            return undefined;
                        },
                    },
                },
            },
            scales: {
                x: {
                    stacked: true,
                    beginAtZero: true,
                },
                y: {
                    stacked: true,
                    beginAtZero: true,
                },
            },
            indexAxis: "y",
        };
    }
}

export default toNative(CardBalance);
</script>
